import React from 'react';
import ReactDOM from 'react-dom/client';
import 'react-loading-skeleton/dist/skeleton.css';
import 'react-redux-toastr/lib/css/react-redux-toastr.min.css';
import 'assets/fonts/sofia-pro/stylesheet.css';
import 'assets/icomoon/style.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import StyleProvider from '@yubi/yb-style-provider';
import { Provider } from 'react-redux';
import { PhoenixIconProvider } from '@yubi/yb-core-icon';
import PhoenixProvider from '@yubi/phoenix-provider';
import store from './store';
import { BrowserRouter, RouterProvider, Routes } from 'react-router-dom';
import ReduxToastr from 'react-redux-toastr';
import { ToastProvider } from '@yubi/yb-core-snackbar-v3';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
    <React.StrictMode>
        <Provider store={store}>
            <PhoenixProvider
                baseUrl={`${process.env.REACT_APP_PHOENIX_TOKENS_API_BASE_URL}`}
                customSpriteFilePath="/icon.svg"
            >
                <ToastProvider>
                    <StyleProvider baseUrl={`${process.env.REACT_APP_PHOENIX_TOKENS_API_BASE_URL}`}>
                        <BrowserRouter>
                            <App />
                        </BrowserRouter>
                    </StyleProvider>
                </ToastProvider>
            </PhoenixProvider>
            <ReduxToastr preventDuplicates timeout={3000} />
        </Provider>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
